import { useState, useEffect } from "react";
import { useAppDispatch } from "../../app/hook";
import { useParams, useNavigate } from "react-router-dom";
import { showModal } from "../UI/modal/modal-slice";
import {
  SpaceBetween,
  Button,
  ColumnLayout,
  Form,
  Box,
} from "@cloudscape-design/components-themed";
import { MerchantTable } from "./MerchantTable";
import InputForm from "./InputForm";
import { RateAdjustmentCaseCorpInfo } from "../../features/api-interfaces";
import { COMMON_LABELS } from "../default-constants";
import {
  usePostRateAdjustmentCaseRegisterMutation,
  useGetCorpInfoByCorpNumQuery,
} from "../../features/api";
import {
  isNull,
  isHalfNumberValid,
  isLengthFixedValid,
} from "../../utils/inputValidation";
import { getMessage } from "../../features/error/messages";

/*===================================================================================
 * 料率調整案件登録更新画面
 * 概要：料率調整案件登録・更新画面を表示し、一覧表と項目更新機能を実装
 *
 * 前の画面からの必要なパラメーター
 * なし
 *
 * 遷移先：なし
 * 戻り先：料率調整案件一覧画面
 ===================================================================================*/
//未実装：更新関連
const Main = (props: any) => {
  const { rateAdjustmentCaseNo } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [postRateAdjustmentCase] = usePostRateAdjustmentCaseRegisterMutation();

  // 登録画面か更新画面かのフラグ
  const isRegister = !rateAdjustmentCaseNo;

  //入力フォームの活性化フラグ
  const [isInputEditable, setIsInputEditable] = useState(false);

  //戻るボタンの表示確認フラグ（入力フォームに何か入力された場合はtrue）
  const [isFormEntered, setIsFormEntered] = useState(false);

  //法人番号検索実施フラグ
  const [isCorporateNumberSearchClicked, setIsCorporateNumberSearchClicked] =
    useState(false);

  //登録ボタンの活性化フラグ
  const [isRegistrationButton, setIsRegistrationButton] = useState(true);

  // 事業者情報(登録更新時BE送信用)
  let rateAdjustmentCase = {
    corporateNumber: "",
    companyName: "",
    companyNameKana: "",
    address: "",
  } as RateAdjustmentCaseCorpInfo;

  //入力フォーム活性・非活性制御
  useEffect(() => {
    //更新の場合、活性化する
    if (!isRegister) {
      setIsInputEditable(true);
    } else {
      //新規登録の場合、法人番号検査押下したかチェック
      if (isCorporateNumberSearchClicked) {
        setIsInputEditable(true);
      }
    }
  }, [isRegister, isCorporateNumberSearchClicked]);

  //法人番号検索条件を初期化する(複数回検査できるように、検索時用の変数を用意)
  const [corpNumInput, setCorpNumInput] = useState("");

  //法人番号で料率調整案件の事業者情報取得
  const { data } = useGetCorpInfoByCorpNumQuery(corpNumInput, {
    skip: !corpNumInput,
  });

  //新規の場合、法人番号押下後取得してきた料率調整案件の事業者情報データをセット
  useEffect(() => {
    if (data) {
      if (data.status === "success") {
        setCorporateNumber(corpNumInput);
        setCompanyName(data.companyInfo.companyName);
        setCompanyNameKana(data.companyInfo.companyNameKana);
        setAddress(data.companyInfo.address);
        setIsRegistrationButton(false);

        //法人番号検索フラグを設定
        setIsCorporateNumberSearchClicked(true);

        //検索条件を初期化する
        setCorpNumInput("");
      } else {
        setCorporateNumber("");
        setCompanyName("");
        setCompanyNameKana("");
        setAddress("");
      }
    }
  }, [corpNumInput, data]);

  // 法人番号検索処理
  const onClickCorporateNumberSearch = (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();

    // バリデーションチェック
    if (
      checkCorporateNumber(corporateNumber, setCorporateNumberErrorMsg, true)
    ) {
      setCorpNumInput(corporateNumber);
    }
  };

  //更新の場合のデータをセット

  let rateAdjustmentCaseData = !isRegister
    ? props.rateAdjustmentCaseDataList
    : null;
  const [corporateNumber, setCorporateNumber] = useState("");
  const [corporateNumberErrorMsg, setCorporateNumberErrorMsg] =
    useState<string>("");
  const [companyName, setCompanyName] = useState("");
  const [companyNameErrorMsg, setCompanyNameErrorMsg] = useState<string>("");
  const [companyNameKana, setCompanyNameKana] = useState("");
  const [companyNameKanaErrorMsg, setCompanyNameKanaErrorMsg] =
    useState<string>("");
  const [address, setAddress] = useState("");
  const [addressErrorMsg, setAddressErrorMsg] = useState<string>("");

  useEffect(() => {
    if (
      rateAdjustmentCaseData !== undefined &&
      rateAdjustmentCaseData !== null
    ) {
      setCorporateNumber(rateAdjustmentCaseData.corporateNumber);
      setCompanyName(rateAdjustmentCaseData.companyName);
      setCompanyNameKana(rateAdjustmentCaseData.companyNameKana);
      setAddress(rateAdjustmentCaseData.companyAddress);
    }
  }, [rateAdjustmentCaseData]);

  //必須チェック
  const checkNull = (target: string, paramSetErrorMsg: any) => {
    const setErrorMsg = paramSetErrorMsg;
    if (isNull(target)) {
      setErrorMsg(getMessage("KGRERR055").label);
      return false;
    }
    setErrorMsg("");
    return true;
  };

  // 法人番号の入力チェック
  const checkCorporateNumber = (
    target: string,
    paramSetErrorMsg: any,
    checkLengthFlag: boolean
  ) => {
    const setErrorMsg = paramSetErrorMsg;
    // 必須
    if (!checkNull(target, setErrorMsg)) {
      return false;
    }
    // 文字長(入力時の文字数チェックが不要)
    if (checkLengthFlag) {
      if (!isLengthFixedValid(target, 13)) {
        setErrorMsg(getMessage("KGRERR073", 13).label);
        return false;
      }
    }
    // 半角数値
    if (!isHalfNumberValid(target)) {
      setErrorMsg(getMessage("KGRERR006").label);
      return false;
    }
    setErrorMsg("");
    return true;
  };

  //バリエーションチェック
  const checkCorporate = () => {
    let checkResult = true;
    if (
      !checkCorporateNumber(corporateNumber, setCorporateNumberErrorMsg, true)
    ) {
      checkResult = false;
    }
    if (!checkNull(companyName, setCompanyNameErrorMsg)) {
      checkResult = false;
    }
    if (!checkNull(address, setAddressErrorMsg)) {
      checkResult = false;
    }
    return checkResult;
  };

  //登録ボタン　API作成完了後また修正
  const onClickRegister = () => {
    //バリエーションチェック
    if (!checkCorporate()) return;

    //入力した内容を詰める;
    rateAdjustmentCase.corporateNumber = corporateNumber;
    rateAdjustmentCase.companyName = companyName;
    rateAdjustmentCase.companyNameKana = companyNameKana;
    rateAdjustmentCase.address = address;

    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.REGISTER_CONFIRM,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          postRateAdjustmentCase(rateAdjustmentCase).then((result: any) => {
            if (!("error" in result) && "error" !== result.data.status) {
              navigate(
                "/rate-adjustment-case/" + result.data.rateAdjustmentCaseNo
              );
            }
          });
        },
      })
    );
  };
  //戻るボタン　一覧画面完了後修正
  const onClickReturn = () => {
    if (!isFormEntered) {
      navigate("/rate-adjustment-case-list");
    } else {
      dispatch(
        showModal({
          title: COMMON_LABELS.TITLES.DL,
          content: COMMON_LABELS.CONTENTS.PAGE_MOVE_CONFIRM,
          positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
          negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
          positiveFn: () => {
            navigate("/rate-adjustment-case-list");
          },
        })
      );
    }
  };

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Form
        actions={<SpaceBetween direction="horizontal" size="xs"></SpaceBetween>}
      >
        <SpaceBetween size="l">
          <SpaceBetween direction="vertical" size="l">
            <InputForm
              isRegister={isRegister}
              isInputEditable={isInputEditable}
              onClickCorporateNumberSearch={onClickCorporateNumberSearch}
              setIsFormEntered={setIsFormEntered}
              corporateNumber={corporateNumber}
              setCorporateNumber={setCorporateNumber}
              corporateNumberErrorMsg={corporateNumberErrorMsg}
              setCorporateNumberErrorMsg={setCorporateNumberErrorMsg}
              checkCorporateNumber={checkCorporateNumber}
              companyName={companyName}
              setCompanyName={setCompanyName}
              companyNameErrorMsg={companyNameErrorMsg}
              setCompanyNameErrorMsg={setCompanyNameErrorMsg}
              companyNameKana={companyNameKana}
              setCompanyNameKana={setCompanyNameKana}
              companyNameKanaErrorMsg={companyNameKanaErrorMsg}
              setCompanyNameKanaErrorMsg={setCompanyNameKanaErrorMsg}
              address={address}
              setAddress={setAddress}
              addressErrorMsg={addressErrorMsg}
              setAddressErrorMsg={setAddressErrorMsg}
              checkNull={checkNull}
              isRegistrationButton={isRegistrationButton}
              setIsRegistrationButton={setIsRegistrationButton}
            />
            {!isRegister && (
              <MerchantTable
                isRegister={isRegister}
                isInputEditable={isInputEditable}
                merchantDetailDataList={props.merchantList}
                rateAdjustmentCaseNo={rateAdjustmentCaseNo}
                isFetching={props.isFetching}
              />
            )}
            <ColumnLayout columns={2}>
              <Box float="left">
                <Button
                  formAction="none"
                  variant="link"
                  onClick={onClickReturn}
                >
                  {COMMON_LABELS.BTNS.BACK}
                </Button>
              </Box>
              {isRegister && (
                <Box float="right">
                  <Button
                    onClick={onClickRegister}
                    variant="primary"
                    disabled={isRegistrationButton}
                  >
                    {COMMON_LABELS.BTNS.REGISTER}
                  </Button>
                </Box>
              )}
            </ColumnLayout>
          </SpaceBetween>
        </SpaceBetween>
      </Form>
    </form>
  );
};
export default Main;
